package fyi.moko.hotpl.data.network

import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

/**
 * A JS number, not a boxed Kotlin `Long` — see [FirestoreLong] for why. The Web SDK turns a
 * safe-integer number into Firestore's `integerValue`, which is what the deployed rules check.
 */
internal actual fun encodeFirestoreLong(encoder: Encoder, value: Long) {
    encoder.encodeDouble(value.toDouble())
}

internal actual fun decodeFirestoreLong(decoder: Decoder): Long = decoder.decodeDouble().toLong()
